import isEqual from "lodash/isEqual";
import pluralize from "pluralize";
import PropTypes from "prop-types";

export const PaginationInfo = ({
  page,
  perPage,
  totalCount,
  rowName,
  className = "",
}) => {
  const startRange = (page - 1) * perPage + 1;
  const endRange = Math.min(page * perPage, totalCount);
  const pluralizedRowName = pluralize(rowName, totalCount, false);

  return (
    <div className={className}>
      {isEqual(totalCount, 0)
        ? `${totalCount} ${pluralizedRowName}`
        : `${startRange}-${endRange} of ${totalCount} ${pluralizedRowName}`}
    </div>
  );
};

PaginationInfo.propTypes = {
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  rowName: PropTypes.string.isRequired,
  className: PropTypes.string,
};
